export const GET_RESTAURANTS = "GET_RESTAURANTS";
export const RESTAURANT_ERROR = "RESTAURANT_ERROR";
export const GET_RESTAURANT_PRODUCTS = "GET_RESTAURANT_PRODUCTS";
export const LOADING = "LOADING";
export const LOADED = "LOADED";
